import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  gap: 20px;
`

export const WrapperList = styled.div`
  margin-bottom: 10px;
`
